import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_CONTAINER_DETAIL,
    getContainerDetailFail,
    getContainerDetailSuccess
} from '../action/getContainerDetailAction'

// api 
import getContainerDetailApi from '../api/getContainerDetailApi'

export function* getContainerDetailSaga(action) {
    try {
        const response = yield call(() => getContainerDetailApi(action.params))
        if (response.data.status === 1) {
            yield put(getContainerDetailSuccess(response, action))
        } else {
            yield put(getContainerDetailFail(response, action))
        }
    }
    catch (e) {
        yield put(getContainerDetailFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_CONTAINER_DETAIL, getContainerDetailSaga)
}